<template>
  <div>
    <mdb-container class="mt-5 content-area viral-finder mt-5">
      <PageHeader text="PROFILE SPY"></PageHeader>

      <div class="d-flex justify-content-center mt-5" v-if="isLoading">
        <div class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <div class v-if="!isLoading">
        <mdb-alert v-if="showAlert" class="d-flex justify-content-center" color="danger">
          <b>Oh no,</b>
        </mdb-alert>
        <ViralFinderSearchForm></ViralFinderSearchForm>
      </div>

      <div class="row">
        <div class="col-md-3"></div>
      </div>
      <div v-if="!igResultsEmpty && !isLoading">
        <hr />
        <p class="bold text-center small">Basic information</p>
        <div class="row">
          <div class="col-md-4">
            <AdminCard
              :text="igUser.followers_count"
              title="Follower"
              icon="fa-users"
              type="danger"
            />
          </div>
          <div class="col-md-4">
            <AdminCard :text="igUser.follows_count" title="Follows" icon="fa-users" type="success" />
          </div>
          <div class="col-md-4">
            <AdminCard
              :text="igUser.media_count"
              title="uploaded media"
              icon="fa-camera"
              type="dark"
            />
          </div>
          <div class="col-md-4">
            <AdminCard
              :text="avgEngagement"
              title="AVG ENGAGEMENT/POST"
              icon="far fa-heart"
              type="info"
            />
          </div>
          <div class="col-md-4">
            <AdminCard
              :text="avgEngagementRate"
              title="AVG ENGAGEMENT RATE"
              icon="fa-percentage"
              type="warning"
            />
          </div>
          <div class="col-md-4">
            <AdminCard
              :text="Number(postsPerDayResults.avgPostsPerDay).toFixed(0)"
              title="AVG POSTS / DAY"
              icon="fa-camera"
              type="primary"
            />
          </div>
        </div>
        <hr />
        <p class="bold text-center small">Hashtag information</p>
        <div class="row">
          <div class="col-md-8">
            <mdb-horizontal-bar-chart
              :data="usedHashtags"
              :options="usedHashtagsOptions"
              :height="150"
            ></mdb-horizontal-bar-chart>
          </div>
          <div class="col-md-4">
            <AdminCard
              :text="Number(usedHashtags.hashtagsPerPost).toFixed(0)"
              title="AVG HASHTAGS/POST"
              icon="fa-hashtag"
              type="info"
            />
          </div>
        </div>
        <hr />
        <p class="bold text-center small">Posts per day</p>
        <div class="row">
          <div class="col-md-12">
            <mdb-line-chart :data="postsPerDay" :options="postsPerDayOptions" :height="100"></mdb-line-chart>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-8">
            <p class="bold text-center small">media count by type</p>
            <mdb-doughnut-chart
              :data="mediaCountByType"
              :options="doughnutChartOptions"
              :width="400"
              :height="200"
            ></mdb-doughnut-chart>
          </div>
          <div class="col-md-4">
            <p class="bold text-center small">Avg. engagement / media type</p>
            <div>
              <div class="row">
                <div class="col-md-12">
                  <AdminCard
                    :text="Number(mediaCountByType.eg.imageEg).toFixed(0)"
                    title="AVG ENGAGEMENT / IMAGE"
                    icon="fa-camera"
                    type="danger"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <AdminCard
                    :text="Number(mediaCountByType.eg.videoEg).toFixed(0)"
                    title="AVG ENGAGEMENT / VIDEO"
                    icon="fa-play"
                    type="dark"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <AdminCard
                    :text="
                    Number(mediaCountByType.eg.carouselEg).toFixed(0)
                  "
                    title="AVG ENGAGEMENT / CAROUSEl"
                    icon="far fa-images"
                    type="primary"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mdb-container>
  </div>
</template>

<script>
import {
  mdbContainer,
  mdbAlert,
  mdbDoughnutChart,
  mdbLineChart,
  mdbHorizontalBarChart
} from "mdbvue";
import PageHeader from "../../components/PageHeader";
import ViralFinderSearchForm from "../../components/viral-finder/ViralFinderSearchForm";
import AdminCard from "@/components/AdminCard";
//import InstagramPost from "../../components/viral-finder/InstagramPost";
export default {
  name: "IGAccountSpy",
  components: {
    mdbContainer,
    mdbAlert,
    PageHeader,
    ViralFinderSearchForm,
    AdminCard,
    mdbDoughnutChart,
    mdbHorizontalBarChart,
    mdbLineChart
    //InstagramPost,
  },
  computed: {
    isLoading: function() {
      return this.$store.getters["ui/isLoading"];
    },
    igUser: function() {
      return this.$store.getters["igViralFinder/igResults"].business_discovery;
    },
    igResultsEmpty: function() {
      const isEmpty =
        Object.entries(this.$store.getters["igViralFinder/igResults"])
          .length === 0;

      return isEmpty;
    },
    media: function() {
      return this.$store.getters["igViralFinder/igMedia"];
    },
    avgEngagement: function() {
      let avgEngagement = 0;
      this.igUser.media.data.forEach(mediaEntry => {
        avgEngagement += mediaEntry.like_count + mediaEntry.comments_count;
      });
      return Number(avgEngagement / this.igUser.media.data.length).toFixed(0);
    },
    avgEngagementRate: function() {
      return Number(
        (this.avgEngagement / this.igUser.followers_count) * 100
      ).toFixed(2);
    },
    mediaCountByType: function() {
      let imagesCount = 0;
      let videosCount = 0;
      let carouselCount = 0;

      let imageEg = 0;
      let videoEg = 0;
      let carouselEg = 0;

      this.igUser.media.data.forEach(mediaEntry => {
        switch (mediaEntry.media_type) {
          case "IMAGE":
            imagesCount++;
            imageEg =
              imageEg + mediaEntry.like_count + mediaEntry.comments_count;
            break;
          case "VIDEO":
            videosCount++;
            videoEg =
              videoEg + mediaEntry.like_count + mediaEntry.comments_count;
            break;
          case "CAROUSEL_ALBUM":
            carouselCount++;
            carouselEg =
              carouselEg + mediaEntry.like_count + mediaEntry.comments_count;
            break;
        }
      });

      const data = [imagesCount, videosCount, carouselCount];
      const labels = ["IMAGES", "VIDEOS", "CAROUSEL POST"];
      const eg = {
        imageEg: imageEg / imagesCount,
        videoEg: videoEg / videosCount,
        carouselEg: carouselEg / carouselCount
      };
      const toReturn = {
        labels: labels,
        datasets: [
          {
            data: data,
            backgroundColor: ["#f44336", "#455A64", "#4285f4"],
            hoverBackgroundColor: ["#F10", "#232E33", "#005ef9"]
          }
        ],
        eg: eg
      };
      return toReturn;
    },
    postsPerDay: function() {
      const media = this.igUser.media.data;
      let postsPerDay = new Map();

      media.forEach(mediaEntry => {
        const date = new Date(mediaEntry.timestamp);
        const diff = Math.abs(new Date() - date);
        const days = diff / (60 * 60 * 24 * 1000);
        if (days > 30) {
          return;
        }
        const key = date.toISOString().substring(0, 10);

        let count = postsPerDay.get(key);
        if (count != null) {
          count += 1;
          postsPerDay.set(key, count);
        } else {
          postsPerDay.set(key, 1);
        }
      });

      // Initialize your keys array
      var keys = [];
      // Initialize your sorted maps object
      var sortedMap = new Map();

      // Put keys in Array
      postsPerDay.forEach(function callback(value, key) {
        keys.push(key);
      });

      // Sort keys array and go through them to put in and put them in sorted map
      keys
        .sort(function compare(a, b) {
          var dateA = new Date(a);
          var dateB = new Date(b);
          return dateA - dateB;
        })
        .map(function(key) {
          sortedMap.set(key, postsPerDay.get(key));
        });

      // View your sorted map
      postsPerDay = sortedMap;

      let labels = [];
      let data = [];

      let avgPostsPerDay = 0;

      postsPerDay.forEach((value, key) => {
        labels.push(key);
        data.push(value);
        avgPostsPerDay += value;
      });

      avgPostsPerDay = avgPostsPerDay / postsPerDay.size;

      return {
        labels: labels,
        datasets: [
          {
            label: "Number of posts",
            backgroundColor: "rgba(134, 193, 251, 0.5)",
            borderColor: "#007bff",
            borderWidth: 0.7,
            data: data
          }
        ],
        avgPostsPerDay: avgPostsPerDay
      };
    },
    usedHashtags: function() {
      const media = this.igUser.media.data;

      const tagUsage = new Map();

      let hashtagsCount = 0;

      media.forEach(mediaEntry => {
        const tags = mediaEntry.caption.split("#");
        tags.shift();

        tags.forEach(tag => {
          hashtagsCount++;
          let usedTag = tagUsage.get(tag.trim());
          if (usedTag != null) {
            usedTag++;
            tagUsage.set(tag.trim(), usedTag);
          } else {
            tagUsage.set(tag.trim(), 1);
          }
        });
      });
      /* eslint-disable */
      let newMap = new Map(
        [...tagUsage].sort(([k, v], [k2, v2]) => {
          if (v < v2) {
            return 1;
          }
          if (v > v2) {
            return -1;
          }
          return 0;
        })
      );
      /* eslint-enable */

      const i = newMap.size >= 10 ? 10 : newMap.size;
      const topTen = new Map();

      for (let index = 0; index < i; index++) {
        var key = Array.from(newMap.keys())[index]; // Returns 'item3'

        // The value of the item at index 2
        var val = newMap.get(key);
        topTen.set(key, val);
      }

      const labels = [];
      const data = [];

      topTen.forEach((value, key) => {
        labels.push(key);
        data.push(value);
      });

      return {
        labels: labels,
        datasets: [
          {
            label: "Number of #",
            data: data,
            backgroundColor: "rgba(134, 193, 251, 0.5)",
            borderColor: "rgba(153, 102, 255, 1)",
            borderWidth: 1
          }
        ],
        hashtagsPerPost: hashtagsCount / media.length
      };
    }
  },
  methods: {},
  data() {
    return {
      doughnutChartOptions: {
        responsive: true,
        maintainAspectRatio: true
      },
      mediaCountByTypeResult: {},
      postsPerDayOptions: {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          xAxes: [
            {
              gridLines: {
                display: true,
                color: "rgba(0, 0, 0, 0.1)"
              }
            }
          ],
          yAxes: [
            {
              gridLines: {
                display: true,
                color: "rgba(0, 0, 0, 0.1)"
              }
            }
          ]
        }
      },
      postsPerDayResults: {},
      usedHashtagsResult: {},
      usedHashtagsOptions: {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          xAxes: [
            {
              barPercentage: 1,
              gridLines: {
                display: true,
                color: "rgba(0, 0, 0, 0.1)"
              }
            }
          ],
          yAxes: [
            {
              gridLines: {
                display: true,
                color: "rgba(0, 0, 0, 0.1)"
              }
            }
          ]
        }
      },
      showAlert: false
    };
  },
  created: function() {},
  mounted: function() {
    if (!this.igResultsEmpty) {
      this.mediaCountByTypeResult = this.mediaCountByType;
      this.postsPerDayResults = this.postsPerDay;
      this.usedHashtagsResult = this.usedHashtags;
    }
  }
};
</script>
